export const account_types_list = [
    { text: "Individual", value: "individual" },
    { text: "Business", value: "business" }
];